import * as React from "react";
import { MapPin, Store, Truck } from "lucide-react";
import { Separator } from "@/components/ui/separator";
const deliveryZones = [{
  title: "Dakar Banlieue & Petite Côte",
  description: "Livraison gratuite à partir de 80 000 FCFA\xA0",
  icon: Truck
}, {
  title: "Thiès\xA0",
  description: "Livraison gratuite à partir de 25 000 FCFA\xA0",
  icon: MapPin
}, {
  title: "Retrait en Boutique",
  description: "Votre commande est préparée et disponible sous 2h dans notre point de vente à Thiès.",
  icon: Store
}];
export default function LivraisonSimpleEtTransparente() {
  return <section id="livraison-simple-et-transparente" className="bg-background py-20">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-foreground mb-12">
          Livraison simple et transparente
        </h2>

        <div className="flex flex-col">
          {deliveryZones.map((zone, i) => <div key={i} data-index={i} className="flex flex-col">
              <div className="flex flex-col sm:flex-row items-start gap-6 py-8">
                <div className="shrink-0 text-ring">
                  <zone.icon size={32} strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <h3 className="font-sans font-bold text-lg text-foreground mb-2">
                    {zone.title}
                  </h3>
                  <p className="font-sans text-base text-muted-foreground leading-relaxed">
                    {zone.description}
                  </p>
                </div>
              </div>
              {i < deliveryZones.length - 1 && <Separator className="bg-border" />}
            </div>)}
        </div>
      </div>
    </section>;
}